import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './ScheduleSection.css';
import { FaClock } from 'react-icons/fa';

const ScheduleSection = ({ 
  isScheduledPost, 
  setIsScheduledPost, 
  scheduledDate, 
  setScheduledDate, 
  scheduledTime, 
  setScheduledTime,
  getCurrentDateTime 
}) => {
  return (
    <div className="ss-container">
      <div className="ss-toggle">
        <input
          type="checkbox"
          id="schedule-toggle"
          checked={isScheduledPost}
          onChange={(e) => setIsScheduledPost(e.target.checked)}
          className="ss-checkbox"
        />
        <label htmlFor="schedule-toggle" className="ss-label">
          <FaClock className="ss-icon" />
          Programmer cette publication
        </label>
      </div>
      
      {isScheduledPost && (
        <div className="ss-inputs">
          <div className="ss-input-group">
            <label className="ss-input-label">Date :</label>
            <input
              type="date"
              value={scheduledDate}
              onChange={(e) => setScheduledDate(e.target.value)}
              className="ss-date-input"
              min={getCurrentDateTime().date}
            />
          </div>
          <div className="ss-input-group">
            <label className="ss-input-label">Heure :</label>
            <input
              type="time"
              value={scheduledTime}
              onChange={(e) => setScheduledTime(e.target.value)}
              className="ss-time-input"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ScheduleSection;
export {ScheduleSection};